import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12
    }
  },
  dialogTitle: {
    padding: spacing(3, 3, 1, 3)
  },
  title: {
    fontWeight: 600
  },
  subtitle: {
    marginTop: spacing(1),
    fontSize: '0.875rem',
    lineHeight: 1.4
  },
  dialogContent: {
    padding: spacing(2, 3)
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(3),
    marginTop: spacing(1)
  },
  formField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8
    }
  },
  statusContainer: {
    padding: spacing(1),
    backgroundColor: palette.grey?.[50] || '#fafafa',
    borderRadius: 8,
    border: `1px solid ${palette.divider || '#e0e0e0'}`
  },
  dialogActions: {
    padding: spacing(2, 3, 3, 3),
    gap: spacing(2)
  }
}))
